import React from 'react'

const Pricing = () => {
  return (
    <div>
      <section className="text-black font-semibold text-lg body-font overflow-hidden m-0">
        <div className="container px-5 py-24 mx-auto">

          <div className="flex flex-col text-center w-full mb-20">
            <h1 className="sm:text-4xl text-3xl font-semibold title-font mb-2 text-gray-900"> Website Development Packages</h1>
            <p className="lg:w-2/3 mx-auto leading-relaxed text-base text-gray-500"></p>

          </div>


          <div className="flex flex-wrap -m-4">

            <div className="p-4 xl:w-1/3 md:w-1/2 w-full">
              <div className="h-full p-6 rounded-lg border-2 border-blue-900 flex flex-col relative overflow-hidden">
                <h2 className="text-2xl tracking-widest title-font mb-5  text-center  text-black font-semibold">STARTUP BUSINESS PACKAGE</h2>
                <h1 className="text-2xl text-gray-900 pb-4 mb-6 text-center font-bold  border-b border-gray-200 leading-none">₹10,000</h1>

                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Upto 5 pages
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>Domain-1st Year Free
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>1 Email – 500 MB Quota
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> 1 Contact Form
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>Free SSL
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Testimonials
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Gallery Section
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center  bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> 300 Rs/Extra Page
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Mobile Responsive
                </p>

                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Delivery in 10 Days
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  ❌ Renewal – 2000 Rs + Domain Price Plus GST
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  ❌ Support – 500 Rs/Hr
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  ❌ Payments
                </p>
                <a href="/contact" className="flex items-center  mt-auto text-white hover:text-white bg-blue-900 border-0 py-2 px-4 w-full focus:outline-none hover:bg-indigo-600 rounded">Get Details
                  <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                  </svg>
                </a>
                <p className="text-sm text-black font-semibold mt-3 text-center justify-center">T&C Apply</p>
              </div>
            </div>

            <div className="p-4 xl:w-1/3 md:w-1/2 w-full">
              <div className="h-full p-6 rounded-lg border-2 bg-blue-900 border-blue-900 flex flex-col relative overflow-hidden">
                <span className="bg-yellow-300 text-white font-semibold px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">POPULAR</span>
                <h2 className="text-2xl tracking-widest title-font mb-5  text-center  text-white font-semibold">SMALL BUSINESS  PACKAGE</h2>
                <h1 className="text-2xl text-white pb-4 mb-6 text-center font-bold  border-b border-gray-200 leading-none">₹20,000</h1>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> 10 - 15 Pages
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Domain-1st Year Free
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> 2 Email – 500 MB Quota Each
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> 3 Contact Form
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Free SSL
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Testimonials
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  300 Rs/Extra Page
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  200 Rs – Content/Page
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Mobile Responsive
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Delivery in 20-25 Days
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  Renewal – 2000 Rs + Domain Price Plus GST
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  Free 4 Hours Support
                </p>
                <p className="flex items-center  text-white font-semibold text-lg mb-2">
                  ❌ Payments
                </p>
                <a href="/contact" className="flex items-center  mt-auto text-black hover:text-white bg-yellow-300 border-0 py-2 px-4 w-full focus:outline-none hover:bg-indigo-600 rounded">Get Details
                  <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                  </svg>
                </a>
                <p className="text-xs text-white justify-center text-center mt-3">T&C Apply</p>
              </div>
            </div>

            <div className="p-4 xl:w-1/3 md:w-1/2 w-full">
              <div className="h-full p-6 rounded-lg border-2 border-blue-900 flex flex-col relative overflow-hidden">
                <span className="bg-yellow-300 text-black font-semibold px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">PRO</span>

                <h2 className="text-2xl tracking-widest title-font mb-5  text-center  text-black font-semibold">ECOMMERCE BUSINESS PACKAGE</h2>
                <h1 className="text-2xl text-gray-900 pb-4 mb-6 text-center font-bold  border-b border-gray-200 leading-none">₹40,000 - ₹50,000 </h1>
             
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  Up to 50 Products
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  Domain-1st Year Free
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  Free SSL
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  4  Contact Form
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> 4 Email – 500 MB Quota Each
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>  300 Rs/Extra Page
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> WhatsApp Chat Integration
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Payment Gateway
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Revisions – 2
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Delivery in 30 Days
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Renewal – 2000 Rs + Domain Price Plus GST
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Extra Support – 500 Rs/Hour
                </p>
                <p className="flex items-center  text-black font-semibold text-lg mb-2">
                  <span className="w-5 h-5 mr-2 inline-flex items-center justify-center bg-green-500 text-white rounded-full flex-shrink-0">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-4 h-4" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span> Call/Email/Chat Support
                </p>

                <a href="/contact" className="flex items-center  mt-auto text-white hover:text-white bg-blue-900 border-0 py-2 px-4 w-full focus:outline-none hover:bg-indigo-600 rounded">Get Details
                  <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                  </svg>
                </a>
                <p className="text-sm text-black font-semibold mt-3 text-center justify-center">T&C Apply</p>
              </div>
            </div>



          </div>
        </div>
      </section>
    </div>
  )
}

export default Pricing